import { useEffect } from 'react';
import { ICategoryToIconMap } from '../categoryToIconMap';

export const useScrollToActiveChip = (
    refs: Array<React.RefObject<HTMLButtonElement> | undefined>,
    categories: Array<ICategoryToIconMap>,
    selectedCategory: ICategoryToIconMap,
    setInitialScrollPosition: React.Dispatch<React.SetStateAction<number>>,
) => {
    useEffect(() => {
        const selectedIndex = categories.findIndex(
            (category) => category === selectedCategory,
        );
        const currentRef = refs[selectedIndex];

        setInitialScrollPosition((currentRef?.current?.offsetLeft ?? 0) - 48);
        // Only run this on initial page load
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
